<template>
  <div class="xc_upload">
    <div class="image-list" v-for="(item, index) in imageList" :key="index" :draggable="true"
         @dragover="onDragover" @drag="dragItem(index)" @drop="dropItem(index)">
      <el-image :src="item" ></el-image>
      <div class="mask"></div>
      <i class="el-icon-delete" @click="deleteImage(item)"></i>
    </div>
    <el-upload
        v-if="imageList.length < limitNum"
        class="upload-box"
        :action="baseURL + '/upload'"
        :headers="{token: token}"
        list-type="picture-card"
        :limit="limitNum"
        multiple
        accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.GIF"
        :before-upload="beforeUpload"
        :on-change="uploadPicture">
      <div class="picture-box">
        <div class="upload-picture"></div>
        <el-button type="info" >点击上传图片</el-button>
        <div class="upload-text"></div>
        <div slot="tip" class="el-upload__tip">推荐尺寸750*694</div>
      </div>
    </el-upload>
  </div>
</template>
<script>
export default {
  props: {
    // 上传张数
    limit: {
      type: Number,
      default: 1
    },
    // 已有图片
    img: {
      type: Array,
      default () {
        return []
      }
    },
    size: {
      type: Number,
      default: 20
    }
  },
  watch: {
    img (newV) {
      this.imageList = newV
    }
  },
  data () {
    return {
      baseURL: this.baseUrl,
      token: localStorage.getItem('token'),
      limitNum: this.limit,
      imageList: this.img,
      myWidth: this.width,
      selectNum: null
    }
  },
  methods: {
    // 上传图片
    uploadPicture (file) {
      console.log(file)
      if (file.response && file.response.code === '200') {
        this.$message.success('上传成功')
        this.imageList.push(file.response.msg)
        this.$emit('success', this.imageList)
      }
    },
    // 上传图片之前的操作
    beforeUpload (file) {
      const isLt5M = file.size / 1024 / 1024 < this.size
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 ' + this.size + 'MB!')
      }
      return isLt5M
    },
    // 删除图片
    deleteImage (url) {
      let data = new FormData()
      data.append('url', url)
      this.$http.post('fileDelete', data).then(res => {
        if (res.data.code === '200') {
          this.$message.success(res.data.msg)
          this.imageList.forEach((item, index) => {
            if (item === url) {
              this.imageList.splice(index, 1)
              this.$emit('success', this.imageList)
            }
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onDragover (e) {
      e.preventDefault()
    },
    dragItem (num) {
      this.selectNum = num
    },
    dropItem (num) {
      if (this.selectNum === num) return
      this.imageList.splice(num, 1, ...this.imageList.splice(this.selectNum, 1, this.imageList[num]))
      this.$emit('success', this.imageList)
    }
  }
}
</script>
<style lang="less">
.xc_upload {
  display: flex;
  flex-wrap: wrap;
  .el-upload-list {
    display: none;
  }
  .image-list {
    position: relative;
    box-sizing: border-box;
    width: 375px;
    height: 347px;
    margin-right: 2px;
    border: 2px solid #c0ccda;
    border-radius: 6px;
    &:hover .mask,
    &:hover .el-icon-delete{
      display: block;
    }
    .el-image {
      width: 100%;
      height: 100%;
    }
    .mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: none;
      z-index: 998;
      transition: all 1s;
    }
    .el-icon-delete {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      font-size: 20px;
      display: none;
      z-index: 999;
    }
  }
  .upload-box {
    position: relative;
    .el-upload.el-upload-list--picture-card {
      display: inline-block;
      height: 347px;
      li {
        width: 375px;
        height: 100%;
        margin: 0;
      }
    }
    .el-upload.el-upload--picture-card {
      width: 375px;
      height: 347px;
      line-height: normal;
    }
    .picture-box {
      width: 100%;
      height: 70%;
      margin-top: 20%;
      .upload-picture {
        width: 100%;
        height: 30%;
        margin-bottom: 2%;
        background: url('../assets/images/upload.png') no-repeat center;
        background-size: contain;
      }
      .el-button {
        margin-bottom: 4%;
      }
      .upload-text {
        width: 80%;
        margin: auto;
        color: #ccc;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/xcUpload.vue